import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { MyUtils } from "src/app/services/my-utils.service";

export interface Logout {
  title: "";
  question: "";
  yes: "";
  no: "";
}

@Component({
  selector: "app-action-dialog",
  templateUrl: "./action-dialog.component.html",
  styleUrls: ["./action-dialog.component.css"],
})
export class ActionDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Logout,
    private authService: AuthService,
    private router: Router,
    public utility: MyUtils
  ) {}

  ngOnInit() {}

  logoutUser() {
    this.authService.resetsSubject();
    this.router.navigate(["/login"]);
  }

  
}
